<!-- Modal (Alterar (Rota)) -->

<ng-template #alterarRota let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-alterar-rota"><b>Alterar (Rota)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="height: 360px;">
    <form [formGroup]="formAlterarRota">
      <div class="form-row">
        <div class="form-group col-sm-8">
          <label><b>Nome:</b></label>

          <input class="form-control form-control-sm" type="text" name="alterar_rota_nome" maxlength="50" [ngClass]="{ 'is-invalid': enviadoAlterarRota && far.rota_nome.errors?.required }" formControlName="rota_nome" />

          @if (enviadoAlterarRota && far.rota_nome.errors?.required) {
            <div class="erro pt-1">Nome em branco!</div>
          }
        </div>

        <div class="form-group col-sm-4">
          <label><b>Dia (Visita):</b></label>

          <input class="form-control form-control-sm" type="text" name="alterar_rota_dia_visita" [ngClass]="{ 'is-invalid': far.rota_dia_visita.errors?.invalid }" ngbDatepicker #alterar_rota_dia_visita="ngbDatepicker" (click)="alterar_rota_dia_visita.toggle()" formControlName="rota_dia_visita" />

          @if (far.rota_dia_visita.errors?.invalid) {
            <div class="erro pt-1">Dia (Visita) inválido!</div>
          }
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="submit" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Modal (Duplicar (Cliente)) -->

<ng-template #duplicarCliente let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-duplicar-cliente"><b>Duplicar (Cliente)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Cliente:</b></label>

        <input class="form-control form-control-sm" type="text" name="duplicar_cliente_cliente" [value]="duplicarRotaSelecionada == null ? '' : duplicarRotaSelecionada.name" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="form-row">
      <div class="form-group col-sm-10">
        <label><b>Enviar p/ rota:</b></label>

        <select class="form-control form-control-sm" name="rota_destino_0" #rota_destino_0 (change)="definirPosicoesRotaDestino($event.target.value)">
          @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
            <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
          }
        </select>
      </div>

      <div class="form-group col-sm-2">
        <label><b>Posição:</b></label>

        <select class="form-control form-control-sm" name="rota_posicao_0" #rota_posicao_0 (change)="definirPosicao($event.target.value)">
          @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
            <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
          }
        </select>

        <hr class="mt-2 mb-2" />
      </div>
    </div>

    @if (false && resultadoImportacaoRotas) {
      <div class="alert alert-light border mt-3 mb-0">
        <div class="mb-2">
          <b>Resultado da importaÃ§Ã£o:</b>
          {{ resultadoImportacaoRotas.importadas || 0 }} importado(s),
          {{ resultadoImportacaoRotas.atualizadas || 0 }} atualizado(s),
          {{ resultadoImportacaoRotas.erros ? resultadoImportacaoRotas.erros.length : 0 }} erro(s).
        </div>

        @if (resultadoImportacaoRotas.vendedores && resultadoImportacaoRotas.vendedores.length > 0) {
          <div class="mb-2">
            <b>Por vendedor:</b>
            <div class="table-responsive mt-1">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Vendedor</th>
                    <th>Importados</th>
                    <th>Atualizados</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  @for (vendedor of resultadoImportacaoRotas.vendedores; track vendedor) {
                    <tr>
                      <td>{{ vendedor.codigo_erp_vendedor }}</td>
                      <td>{{ vendedor.importadas }}</td>
                      <td>{{ vendedor.atualizadas }}</td>
                      <td>{{ vendedor.total }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (resultadoImportacaoRotas.erros && resultadoImportacaoRotas.erros.length > 0) {
          <div>
            <b>Registros nÃ£o importados:</b>
            <div class="table-responsive mt-1" style="max-height: 180px; overflow-y: auto;">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Linha</th>
                    <th>Cliente</th>
                    <th>Vendedor</th>
                    <th>Rota</th>
                    <th>Erro</th>
                  </tr>
                </thead>
                <tbody>
                  @for (erro of resultadoImportacaoRotas.erros; track erro) {
                    <tr>
                      <td>{{ erro.linha }}</td>
                      <td>{{ erro.codigo_erp_cliente }}</td>
                      <td>{{ erro.codigo_erp_vendedor }}</td>
                      <td>{{ erro.nome_rota }}</td>
                      <td>{{ erro.erro }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Duplicar')">Duplicar</button>
  </div>
</ng-template>

<!-- Modal (Mover Cliente Sem Rota) -->

<ng-template #moverClienteSemRota let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-mover-cliente-sem-rota"><b>Mover para Rota</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Cliente:</b></label>

        <input class="form-control form-control-sm" type="text" [value]="movClienteNome" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="form-row">
      <div class="form-group col-sm-10">
        <label><b>Enviar p/ rota:</b></label>

        <select class="form-control form-control-sm" (change)="definirPosicoesRotaDestino($event.target.value)">
          @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
            <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
          }
        </select>
      </div>

      <div class="form-group col-sm-2">
        <label><b>Posição:</b></label>

        <select class="form-control form-control-sm" (change)="definirPosicao($event.target.value)">
          @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
            <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
          }
        </select>
      </div>
    </div>

    @if (false && resultadoImportacaoRotas) {
      <div class="alert alert-light border mt-3 mb-0">
        <div class="mb-2">
          <b>Resultado da importacao:</b>
          {{ resultadoImportacaoRotas.importadas || 0 }} importado(s),
          {{ resultadoImportacaoRotas.atualizadas || 0 }} atualizado(s),
          {{ resultadoImportacaoRotas.erros ? resultadoImportacaoRotas.erros.length : 0 }} erro(s).
        </div>

        @if (resultadoImportacaoRotas.vendedores && resultadoImportacaoRotas.vendedores.length > 0) {
          <div class="mb-2">
            <b>Por vendedor:</b>
            <div class="table-responsive mt-1">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Vendedor</th>
                    <th>Importados</th>
                    <th>Atualizados</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  @for (vendedor of resultadoImportacaoRotas.vendedores; track vendedor) {
                    <tr>
                      <td>{{ vendedor.codigo_erp_vendedor }}</td>
                      <td>{{ vendedor.importadas }}</td>
                      <td>{{ vendedor.atualizadas }}</td>
                      <td>{{ vendedor.total }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (resultadoImportacaoRotas.erros && resultadoImportacaoRotas.erros.length > 0) {
          <div>
            <b>Registros nao importados:</b>
            <div class="table-responsive mt-1" style="max-height: 260px; overflow-y: auto;">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Linha</th>
                    <th>Cliente</th>
                    <th>Vendedor</th>
                    <th>Rota</th>
                    <th>Erro</th>
                  </tr>
                </thead>
                <tbody>
                  @for (erro of resultadoImportacaoRotas.erros; track erro) {
                    <tr>
                      <td>{{ erro.linha }}</td>
                      <td>{{ erro.codigo_erp_cliente }}</td>
                      <td>{{ erro.codigo_erp_vendedor }}</td>
                      <td>{{ erro.nome_rota }}</td>
                      <td>{{ erro.erro }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Mover')">Mover</button>
  </div>
</ng-template>

<!-- Modal (Excluir Rota) -->

<ng-template #excluirRota let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-excluir-rota"><b>Excluir Rota</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>Deseja realmente excluir rota selecionada?</b></h5>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Nao')">Não</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Sim')">Sim</button>
  </div>
</ng-template>

<!-- Modal (Iniciar (Rotas)) -->

<ng-template #iniciarRotas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-iniciar-rotas"><b>Iniciar (Rotas)</b></h3>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>

        <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)">
          @for (opcao of vendedores; track opcao) {
            <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    @if (resultadoImportacaoRotas) {
      <div class="w-100 alert alert-light border mb-3 text-left">
        <div class="mb-2">
          <b>Resultado da importacao:</b>
          {{ resultadoImportacaoRotas.importadas || 0 }} importado(s),
          {{ resultadoImportacaoRotas.atualizadas || 0 }} atualizado(s),
          {{ resultadoImportacaoRotas.erros ? resultadoImportacaoRotas.erros.length : 0 }} erro(s).
        </div>

        @if (resultadoImportacaoRotas.vendedores && resultadoImportacaoRotas.vendedores.length > 0) {
          <div class="mb-2">
            <b>Por vendedor:</b>
            <div class="table-responsive mt-1">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Vendedor</th>
                    <th>Importados</th>
                    <th>Atualizados</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  @for (vendedor of resultadoImportacaoRotas.vendedores; track vendedor) {
                    <tr>
                      <td>{{ vendedor.codigo_erp_vendedor }}</td>
                      <td>{{ vendedor.importadas }}</td>
                      <td>{{ vendedor.atualizadas }}</td>
                      <td>{{ vendedor.total }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (resultadoImportacaoRotas.erros && resultadoImportacaoRotas.erros.length > 0) {
          <div>
            <b>Registros nao importados:</b>
            <div class="table-responsive mt-1" style="max-height: 260px; overflow-y: auto;">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Linha</th>
                    <th>Cliente</th>
                    <th>Vendedor</th>
                    <th>Rota</th>
                    <th>Erro</th>
                  </tr>
                </thead>
                <tbody>
                  @for (erro of resultadoImportacaoRotas.erros; track erro) {
                    <tr>
                      <td>{{ erro.linha }}</td>
                      <td>{{ erro.codigo_erp_cliente }}</td>
                      <td>{{ erro.codigo_erp_vendedor }}</td>
                      <td>{{ erro.nome_rota }}</td>
                      <td>{{ erro.erro }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
    @if (podeImportarExportarRotas) {
      <input #arquivoImportarRotas type="file" class="d-none" accept=".xlsx" (change)="selecionarArquivoImportacaoRotas($event)" />
      <button class="btn btn-outline-secondary btn_formulario" type="button" (click)="baixarModeloImportacaoRotas()" [disabled]="baixandoModeloRotas">{{ baixandoModeloRotas ? 'Baixando...' : 'Baixar Modelo' }}</button>
      <button class="btn btn-secondary btn_formulario" type="button" (click)="arquivoImportarRotas.click()" [disabled]="importandoRotas">{{ importandoRotas ? 'Importando...' : 'Importar Rotas' }}</button>
      <button class="btn btn-success btn_formulario mr-auto" type="button" (click)="exportarRotas()" [disabled]="exportandoRotas">{{ exportandoRotas ? 'Exportando...' : 'Exportar Rotas' }}</button>
    }
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Iniciar')">Iniciar</button>
  </div>
</ng-template>

<!-- Modal (Nova (Rota)) -->

<ng-template #novaRota let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-nova-rota"><b>Nova (Rota)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="formNovaRota">
      <div class="form-row">
        <div class="form-group col-sm-9">
          <label><b>Nome:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_nome" maxlength="50" [ngClass]="{ 'is-invalid': enviadoNovaRota && fnr.rota_nome.errors?.required }" formControlName="rota_nome" />

          @if (enviadoNovaRota && fnr.rota_nome.errors?.required) {
            <div class="erro pt-1">Nome em branco!</div>
          }
        </div>

        <div class="form-group col-sm-3">
          <label><b>Dia (Visita):</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_dia_visita" [ngClass]="{ 'is-invalid': fnr.rota_dia_visita.errors?.invalid }" ngbDatepicker #nova_rota_dia_visita="ngbDatepicker" (click)="nova_rota_dia_visita.toggle()" formControlName="rota_dia_visita" />

          @if (fnr.rota_dia_visita.errors?.invalid) {
            <div class="erro pt-1">Dia (Visita) inválido!</div>
          }
        </div>
      </div>

      <hr class="mt-2 mb-2" />

      <!-- Origem -->

      <div class="subtitulo mb-2">Origem</div>

      <div class="form-row">
        <div class="form-group col-sm-2">
          <label><b>Logradouro:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_origem_logradouro" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaOrigem || fnr.rota_origem_logradouro.errors?.required) }" formControlName="rota_origem_logradouro" />

          @if (enviadoNovaRota && fnr.rota_origem_logradouro.errors?.required) {
            <div class="erro pt-1">Logradouro em branco!</div>
          }

          @if (enviadoNovaRota && !novaRotaOrigem && !fnr.rota_origem_logradouro.errors?.required) {
            <div class="erro pt-1">Origem inválida!</div>
          }
        </div>

        <div class="form-group col-sm-3">
          <label><b>Endereço:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_origem_endereco" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaOrigem || fnr.rota_origem_endereco.errors?.required) }" formControlName="rota_origem_endereco" />

          @if (enviadoNovaRota && fnr.rota_origem_endereco.errors?.required) {
            <div class="erro pt-1">Endereço em branco!</div>
          }
        </div>

        <div class="form-group col-sm-2">
          <label><b>Número:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_origem_numero" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaOrigem || fnr.rota_origem_numero.errors?.required) }" formControlName="rota_origem_numero" />

          @if (enviadoNovaRota && fnr.rota_origem_numero.errors?.required) {
            <div class="erro pt-1">Número em branco!</div>
          }
        </div>

        <div class="form-group col-sm-2">
          <label><b>Bairro:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_origem_bairro" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaOrigem || fnr.rota_origem_bairro.errors?.required) }" formControlName="rota_origem_bairro" />

          @if (enviadoNovaRota && fnr.rota_origem_bairro.errors?.required) {
            <div class="erro pt-1">Bairro em branco!</div>
          }
        </div>

        <div class="form-group col-sm-3">
          <label><b>Cidade:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_origem_cidade" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaOrigem || fnr.rota_origem_cidade.errors?.required) }" formControlName="rota_origem_cidade" />

          @if (enviadoNovaRota && fnr.rota_origem_cidade.errors?.required) {
            <div class="erro pt-1">Cidade em branco!</div>
          }
        </div>
      </div>

      <div class="d-flex">
        <div>
          <button class="btn btn-secondary btn_modal" type="button" (click)="abrirMapaOrigem()">Definir no Mapa</button>
        </div>
      </div>

      <hr class="mt-2 mb-2" />

      <!-- Destino -->

      <div class="subtitulo mb-2">Destino</div>

      <div class="form-row">
        <div class="form-group col-sm-2">
          <label><b>Logradouro:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_destino_logradouro" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaDestino || fnr.rota_destino_logradouro.errors?.required) }" formControlName="rota_destino_logradouro" />

          @if (enviadoNovaRota && fnr.rota_destino_logradouro.errors?.required) {
            <div class="erro pt-1">Logradouro em branco!</div>
          }

          @if (enviadoNovaRota && !novaRotaDestino && !fnr.rota_destino_logradouro.errors?.required) {
            <div class="erro pt-1">Destino inválido!</div>
          }
        </div>

        <div class="form-group col-sm-3">
          <label><b>Endereço:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_destino_endereco" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaDestino || fnr.rota_destino_endereco.errors?.required) }" formControlName="rota_destino_endereco" />

          @if (enviadoNovaRota && fnr.rota_destino_endereco.errors?.required) {
            <div class="erro pt-1">Endereço em branco!</div>
          }
        </div>

        <div class="form-group col-sm-2">
          <label><b>Número:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_destino_numero" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaDestino || fnr.rota_destino_numero.errors?.required) }" formControlName="rota_destino_numero" />

          @if (enviadoNovaRota && fnr.rota_destino_numero.errors?.required) {
            <div class="erro pt-1">Número em branco!</div>
          }
        </div>

        <div class="form-group col-sm-2">
          <label><b>Bairro:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_destino_bairro" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaDestino || fnr.rota_destino_bairro.errors?.required) }" formControlName="rota_destino_bairro" />

          @if (enviadoNovaRota && fnr.rota_destino_bairro.errors?.required) {
            <div class="erro pt-1">Bairro em branco!</div>
          }
        </div>

        <div class="form-group col-sm-3">
          <label><b>Cidade:</b></label>

          <input class="form-control form-control-sm" type="text" name="nova_rota_destino_cidade" [ngClass]="{ 'is-invalid': enviadoNovaRota && (!novaRotaDestino || fnr.rota_destino_cidade.errors?.required) }" formControlName="rota_destino_cidade" />

          @if (enviadoNovaRota && fnr.rota_destino_cidade.errors?.required) {
            <div class="erro pt-1">Cidade em branco!</div>
          }
        </div>
      </div>

      <div class="d-flex">
        <div>
          <button class="btn btn-secondary btn_modal" type="button" (click)="abrirMapaDestino()">Definir no Mapa</button>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="submit" (click)="modal.close('Iniciar')">Iniciar</button>
  </div>
</ng-template>

<!-- Modal (Reposicionar (Cliente)) -->

<ng-template #reposicionarCliente let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-reposicionar-cliente"><b>Reposicionar (Cliente)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>De qual forma deseja reposicionar?</b></h5>

      <div class="d-flex justify-content-center p-2">
        <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Automatica')">Automática</button>
        <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Manual')">Manual</button>
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Cliente:</b></label>

        <input class="form-control form-control-sm" type="text" name="reposicionar_cliente_cliente" [value]="reposicionarRotaSelecionada == null ? '' : reposicionarRotaSelecionada.name" disabled />
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
  </div>
</ng-template>

<!-- Modal (Reposicionar (Cliente - Manual)) -->

<ng-template #reposicionarClienteManual let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-reposicionar-cliente-manual"><b>Reposicionar (Cliente) - Manual</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="formReposicionarClienteManual">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Cliente:</b></label>

          <input class="form-control form-control-sm" type="text" name="reposicionar_cliente_manual_cliente" [value]="reposicionarRotaSelecionada == null ? '' : reposicionarRotaSelecionada.name" disabled />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-sm-3">
          <label><b>Latitude:</b></label>

          <input class="form-control form-control-sm" type="text" name="reposicionar_cliente_manual_latitude" [ngClass]="{ 'is-invalid': enviadoReposicionarClienteManual && (frc.latitude.errors?.required || frc.latitude.errors?.invalid) }" formControlName="latitude" />

          @if (enviadoReposicionarClienteManual && frc.latitude.errors?.required) {
            <div class="erro pt-1">Latitude em branco!</div>
          }
          @if (frc.latitude.errors?.invalid) {
            <div class="erro pt-1">Latitude inválida!</div>
          }
        </div>

        <div class="form-group col-sm-3">
          <label><b>Longitude:</b></label>

          <input class="form-control form-control-sm" type="text" name="reposicionar_cliente_manual_longitude" [ngClass]="{ 'is-invalid': enviadoReposicionarClienteManual && (frc.longitude.errors?.required || frc.longitude.errors?.invalid) }" formControlName="longitude" />

          @if (enviadoReposicionarClienteManual && frc.longitude.errors?.required) {
            <div class="erro pt-1">Longitude em branco!</div>
          }
          @if (frc.longitude.errors?.invalid) {
            <div class="erro pt-1">Longitude inválida!</div>
          }
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<div class="container-fluid p-0">
  <!-- Processamento -->

  @if (carregando && processando > 0) {
    <div [@esvanecerDesvanecer]="'in'">
      <div class="d-flex justify-content-center">
        <div class="col-sm-8 pt-4">
          <ngb-progressbar showValue="true" [value]="processando"></ngb-progressbar>
        </div>
      </div>
    </div>
  }

  @if (!carregando) {
    <div [@esvanecerDesvanecer]="'in'">
      <!-- Título -->
      <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 titulo_texto_posicao">
            <div class="titulo_texto">Rotas ({{ mapaRotas.length }}) - {{ vendedorSelecionado.fullname }} ({{ qtdeChamadas }})&nbsp;<i class="fa fa-edit rotas_acoes" placement="right" ngbTooltip="Alterar (Vendedor(a))" (click)="alterarVendedor()"></i></div>
          </div>
          <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
            @if (!rotasSalvar && !novaRotaDefinindoDestino && !novaRotaDefinindoOrigem) {
              <button class="btn btn-success btn_titulo" type="button" (click)="iniciarNovaRota(novaRota)">Nova Rota</button>
            }
            @if (!rotasSalvar && !novaRotaDefinindoDestino && !novaRotaDefinindoOrigem) {
              <button class="btn btn-secondary btn_titulo" type="button" (click)="imprimirRotas()">Imprimir Rota(s)</button>
            }
            @if (rotasSalvar && !rotasNova) {
              <button class="btn btn-success btn_titulo" type="button" (click)="salvarRotas()">Salvar Rota(s)</button>
            }
            @if (rotasNova) {
              <button class="btn btn-success btn_titulo" type="button" (click)="salvarNovaRota(false)">Salvar</button>
            }
            @if (rotasNova) {
              <button class="btn btn-success btn_titulo" type="button" (click)="salvarNovaRota(true)">Salvar (Otimizar)</button>
            }
          </div>
        </div>
      </div>
      <div class="rotas">
        <button class="rotas_fab" type="button" (click)="alternarDragAndDrop()" [title]="exibirDragAndDrop ? 'Ocultar listagem' : 'Exibir listagem'">
          <i class="fa" [ngClass]="exibirDragAndDrop ? 'fa-minus' : 'fa-plus'"></i>
        </button>
        <!-- Filtro de clientes (painel flutuante) -->
        <button class="rotas_filtro_fab" type="button" (click)="alternarFiltro()" [title]="filtroAberto ? 'Fechar filtro' : 'Filtrar clientes'">
          <i class="fa" [ngClass]="(filtroNome || filtroCidade || filtroBairro) ? 'fa-filter' : 'fa-search'"></i>
        </button>
        @if (filtroAberto) {
          <div class="rotas_filtro_painel">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <b>Filtrar clientes</b>
              <i class="fa fa-times rotas_acoes" (click)="alternarFiltro()"></i>
            </div>
            <input class="form-control form-control-sm mb-1" type="text" placeholder="Nome" [value]="filtroNome" (input)="filtroNome = fNome.value" #fNome />
            <input class="form-control form-control-sm mb-1" type="text" placeholder="Cidade" [value]="filtroCidade" (input)="filtroCidade = fCidade.value" #fCidade />
            <input class="form-control form-control-sm mb-1" type="text" placeholder="Bairro" [value]="filtroBairro" (input)="filtroBairro = fBairro.value" #fBairro />
            @if (filtroNome || filtroCidade || filtroBairro) {
              <button class="btn btn-secondary btn-sm w-100" type="button" (click)="limparFiltroClientes()">Limpar</button>
            }
          </div>
        }
        <as-split direction="vertical">
          <!-- Nova Rota / Maps -->
          <as-split-area size="55">
            <!-- 55 -->
            <!-- Nova Rota -->
            @if (rotasNova) {
              <div class="nova_rota_coluna" [ngClass]="!novaRotaExibir ? 'nova_rota_coluna_rotacionada' : ''">
                <div class="d-flex flex-column">
                  <!-- Cabeçalho (Coluna) -->
                  <div class="d-flex flex-column">
                    <div class="d-flex">
                      <div (click)="expandirRecolherNovaRota()">
                        <i class="fa rotas_acoes" [ngClass]="novaRotaExibir ? 'fa-minus' : 'fa-plus'"></i>
                      </div>
                      @if (novaRotaExibir) {
                        <div class="flex-grow-1 rotas_nome">
                          <div class="d-flex flex-column">
                            <div class="d-flex justify-content-between">
                              @if (novaRota != null) {
                                <div>
                                  <b>{{ novaRotaDados.name }} ({{ novaRotaAgrupada.length }})</b>
                                </div>
                              }
                              @if (novaRotaExibir) {
                                <div (click)="iniciarAlterarRota(alterarRota, 0)">
                                  <i class="fa fa-pencil rotas_acoes" placement="left" ngbTooltip="Alterar"></i>
                                </div>
                              }
                            </div>
                            <div class="rotas_descricao">
                              Dia (Visita):
                              @if (novaRotaDados == null || novaRotaDados.dia_visita == null) {
                                -
                              }
                              @if (novaRotaDados != null && novaRotaDados.dia_visita != null) {
                                {{ novaRotaDados.dia_visita | date: 'dd/MM/yyyy' }}
                              }
                            </div>
                            <div class="rotas_descricao">
                              Objetivo: {{ novaRotaTotalObjetivo | currency: 'BRL' : '' }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    @if (!novaRotaExibir) {
                      <div class="rotas_nome_rotacao">
                        @if (novaRota != null) {
                          <div class="rotas_nome_rotacionado">
                            <b>{{ novaRotaDados.name }} ({{ novaRotaAgrupada.length }})</b>
                          </div>
                        }
                      </div>
                    }
                  </div>
                  @if (novaRotaExibir) {
                    <div>
                      @for (novaRota of novaRotaAgrupada; track novaRota) {
                        <div class="rotas_item nova_rota_item">
                          <div class="d-flex">
                            <div class="pr-1">
                              <div class="rotas_numero nova_rota_numero">?</div>
                            </div>
                            <div class="flex-grow-1">
                              <div class="d-flex flex-column">
                                <div>
                                  <b>{{ novaRota.name }}</b>
                                </div>
                                <div>
                                  Objetivo: {{ novaRota.objetivo_de_venda | currency: 'BRL' : '' }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Maps -->
            <google-map width="100%" height="100%" [center]="{lat: latitudeFoco, lng: longitudeFoco}" #maps [zoom]="zoom" (mapClick)="adicionarMarcador($event.latLng.lat(), $event.latLng.lng(), novaRota)">
              <!-- Marcadores = Cliente sem rota -->
              @if (mapaClienteSemRota.length > 0) {
                <!-- Origem -->
                <map-marker [position]="{lat: mapaClienteSemRota[0].origin.lat, lng: mapaClienteSemRota[0].origin.lng}" [visible]="mapaClienteSemRota[0].visible" (mapClick)="onPinSemRotaClick(0)" (mouseenter)="onMouseOver(infoWindowOrigem, maps)" (mouseleave)="onMouseOut(maps)" [options]="{icon: mapaClienteSemRota[0].markerOptions.origin.icon.selecionado ? 'assets/pins/sem_rota/sem_rota_selecao.png' : mapaClienteSemRota[0].markerOptions.origin.icon}">
                  <agm-info-window #infoWindowOrigem [isOpen]="mapaClienteSemRotaPontoSelecionado == 0" [disableAutoPan]="false">
                    <div class="d-flex align-items-baseline">
                      <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(mapaClienteSemRota[0].markerOptions.origin.infoWindow)"></div>
                      @if (!rotasNova) {
                        <div class="rotas_informacao">
                          <div class="form-group col-sm-12">
                            <label>Enviar p/ rota:</label>
                            <select class="form-control form-control-sm" name="rota_destino_1" #rota_destino_1 (change)="definirPosicoesRotaDestino($event.target.value)">
                              @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
                                <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
                              }
                            </select>
                          </div>
                          <div class="form-group col-sm-12">
                            <label>Posição:</label>
                            <select class="form-control form-control-sm" name="rota_posicao_1" #rota_posicao_1 (change)="definirPosicao($event.target.value)">
                              @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
                                <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
                              }
                            </select>
                            <hr class="mt-2 mb-2" />
                          </div>
                          <div class="col-sm-12">
                            <div class="d-flex justify-content-center">
                              <div>
                                <button class="btn btn-success btn_rotas_informacao" (click)="modalReposicionarCliente(reposicionarCliente, true, 0)">Reposicionar</button>
                              </div>
                              <div class="pl-2">
                                <button class="btn btn-success btn_rotas_informacao" (click)="moverPonto(0, true)">Mover</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </agm-info-window>
                </map-marker>
                <!-- Destino -->
                <map-marker [position]="{lat: mapaClienteSemRota[0].destination.lat, lng: mapaClienteSemRota[0].destination.lng}" [visible]="mapaClienteSemRota[0].visible" (mapClick)="onPinSemRotaClick(mapaClienteSemRota[0].waypoints.length + 1)" (mouseenter)="onMouseOver(infoWindowDestino, maps)" (mouseleave)="onMouseOut(maps)" [options]="{icon: mapaClienteSemRota[0].markerOptions.destination.icon.selecionado ? 'assets/pins/sem_rota/sem_rota_selecao.png' : mapaClienteSemRota[0].markerOptions.destination.icon}">
                  <agm-info-window #infoWindowDestino [isOpen]="mapaClienteSemRotaPontoSelecionado == (mapaClienteSemRota[0].waypoints.length + 1)" [disableAutoPan]="false">
                    <div class="d-flex align-items-baseline">
                      <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(mapaClienteSemRota[0].markerOptions.destination.infoWindow)"></div>
                      @if (!rotasNova) {
                        <div class="rotas_informacao">
                          <div class="form-group col-sm-12">
                            <label>Enviar p/ rota:</label>
                            <select class="form-control form-control-sm" name="rota_destino_2" #rota_destino_2 (change)="definirPosicoesRotaDestino($event.target.value)">
                              @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
                                <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
                              }
                            </select>
                          </div>
                          <div class="form-group col-sm-12">
                            <label>Posição:</label>
                            <select class="form-control form-control-sm" name="rota_posicao_2" #rota_posicao_2 (change)="definirPosicao($event.target.value)">
                              @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
                                <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
                              }
                            </select>
                            <hr class="mt-2 mb-2" />
                          </div>
                          <div class="col-sm-12">
                            <div class="d-flex justify-content-center">
                              <div>
                                <button class="btn btn-success btn_rotas_informacao" (click)="modalReposicionarCliente(reposicionarCliente, true, mapaClienteSemRota[0].waypoints.length + 1)">Reposicionar</button>
                              </div>
                              <div class="pl-2">
                                <button class="btn btn-success btn_rotas_informacao" (click)="moverPonto(mapaClienteSemRota[0].waypoints.length + 1, true)">Mover</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </agm-info-window>
                </map-marker>
              }
              <!-- Intermediários -->
              @for (mapaCliente of mapaClienteSemRota; track mapaCliente; let i = $index) {
                @for (waypoint of mapaCliente.waypoints; track waypoint; let j = $index) {
                  <map-marker [position]="{lat: waypoint.location.lat, lng: waypoint.location.lng}" [visible]="mapaCliente.visible" (mapClick)="onPinSemRotaClick(j + 1)" (mouseenter)="onMouseOver(infoWindowIntermediarios, maps)" (mouseleave)="onMouseOut(maps)" [options]="{icon: mapaCliente.markerOptions.waypoints[j].icon.selecionado ? 'assets/pins/sem_rota/sem_rota_selecao.png' : mapaCliente.markerOptions.waypoints[j].icon}">
                    <agm-info-window #infoWindowIntermediarios [isOpen]="mapaClienteSemRotaPontoSelecionado == (j + 1)" [disableAutoPan]="false">
                      <div class="d-flex align-items-baseline">
                        <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(mapaCliente.markerOptions.waypoints[j].infoWindow)"></div>
                        @if (!rotasNova) {
                          <div class="rotas_informacao">
                            <div class="form-group col-sm-12">
                              <label>Enviar p/ rota:</label>
                              <select class="form-control form-control-sm" name="rota_destino_3" #rota_destino_3 (change)="definirPosicoesRotaDestino($event.target.value)">
                                @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
                                  <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
                                }
                              </select>
                            </div>
                            <div class="form-group col-sm-12">
                              <label>Posição:</label>
                              <select class="form-control form-control-sm" name="rota_posicao_3" #rota_posicao_3 (change)="definirPosicao($event.target.value)">
                                @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
                                  <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
                                }
                              </select>
                              <hr class="mt-2 mb-2" />
                            </div>
                            <div class="col-sm-12">
                              <div class="d-flex justify-content-center">
                                <div>
                                  <button class="btn btn-success btn_rotas_informacao" (click)="modalReposicionarCliente(reposicionarCliente, true, j + 1)">Reposicionar</button>
                                </div>
                                <div class="pl-2">
                                  <button class="btn btn-success btn_rotas_informacao" (click)="moverPonto(j + 1, true)">Mover</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </agm-info-window>
                  </map-marker>
                }
              }
              <!-- Marcadores = Cliente com rota -->
              <!-- agm-direction: migrar para map-directions-renderer -->
              @for (mapaCliente of mapaClienteComRota; track mapaCliente; let i = $index) {
                <!-- Origem -->
                <map-marker [position]="{lat: mapaClienteComRota[i].origin.lat, lng: mapaClienteComRota[i].origin.lng}" [visible]="mapaClienteComRota[i].visible" (mapClick)="alternarPonto(0, false)" (mouseenter)="onMouseOver(infoWindowOrigem, maps)" (mouseleave)="onMouseOut(maps)" [options]="{icon: mapaClienteComRota[i].markerOptions.origin.icon.selecionado ? 'assets/pins/sem_rota/sem_rota_selecao.png' : mapaClienteComRota[i].markerOptions.origin.icon}">
                  <agm-info-window #infoWindowOrigem [isOpen]="mapaClienteComRotaSelecionado == i && mapaClienteComRotaPontoSelecionado == 0" [disableAutoPan]="false">
                    <div class="d-flex align-items-baseline">
                      <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(mapaClienteComRota[i].markerOptions.origin.infoWindow)"></div>
                      @if (!rotasNova) {
                        <div class="rotas_informacao">
                          <div class="form-group col-sm-12">
                            <label>Enviar p/ rota:</label>
                            <select class="form-control form-control-sm" name="rota_destino_4" #rota_destino_4 (change)="definirPosicoesRotaDestino($event.target.value)">
                              @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
                                <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
                              }
                            </select>
                          </div>
                          <div class="form-group col-sm-12">
                            <label>Posição:</label>
                            <select class="form-control form-control-sm" name="rota_posicao_4" #rota_posicao_4 (change)="definirPosicao($event.target.value)">
                              @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
                                <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
                              }
                            </select>
                            <hr class="mt-2 mb-2" />
                          </div>
                          <div class="col-sm-12">
                            <div class="d-flex justify-content-center">
                              <div>
                                <button class="btn btn-success btn_rotas_informacao" (click)="modalReposicionarCliente(reposicionarCliente, true, 0)">Reposicionar</button>
                              </div>
                              <div class="pl-2">
                                <button class="btn btn-success btn_rotas_informacao" (click)="moverPonto(0, false)">Mover</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </agm-info-window>
                </map-marker>
                <!-- Destino -->
                <map-marker [position]="{lat: mapaClienteComRota[i].destination.lat, lng: mapaClienteComRota[i].destination.lng}" [visible]="mapaClienteComRota[i].visible" (mapClick)="alternarPonto(mapaClienteComRota[i].waypoints.length + 1, false)" (mouseenter)="onMouseOver(infoWindowDestino, maps)" (mouseleave)="onMouseOut(maps)" [options]="{icon: mapaClienteComRota[i].markerOptions.destination.icon.selecionado ? 'assets/pins/sem_rota/sem_rota_selecao.png' : mapaClienteComRota[i].markerOptions.destination.icon}">
                  <agm-info-window #infoWindowDestino [isOpen]="mapaClienteComRotaSelecionado == i && mapaClienteComRotaPontoSelecionado == (mapaClienteComRota[i].waypoints.length + 1)" [disableAutoPan]="false">
                    <div class="d-flex align-items-baseline">
                      <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(mapaClienteComRota[i].markerOptions.destination.infoWindow)"></div>
                      @if (!rotasNova) {
                        <div class="rotas_informacao">
                          <div class="form-group col-sm-12">
                            <label>Enviar p/ rota:</label>
                            <select class="form-control form-control-sm" name="rota_destino_5" #rota_destino_5 (change)="definirPosicoesRotaDestino($event.target.value)">
                              @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
                                <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
                              }
                            </select>
                          </div>
                          <div class="form-group col-sm-12">
                            <label>Posição:</label>
                            <select class="form-control form-control-sm" name="rota_posicao_5" #rota_posicao_5 (change)="definirPosicao($event.target.value)">
                              @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
                                <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
                              }
                            </select>
                            <hr class="mt-2 mb-2" />
                          </div>
                          <div class="col-sm-12">
                            <div class="d-flex justify-content-center">
                              <div>
                                <button class="btn btn-success btn_rotas_informacao" (click)="modalReposicionarCliente(reposicionarCliente, true, mapaClienteComRota[i].waypoints.length + 1)">Reposicionar</button>
                              </div>
                              <div class="pl-2">
                                <button class="btn btn-success btn_rotas_informacao" (click)="moverPonto(mapaClienteComRota[i].waypoints.length + 1, false)">Mover</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </agm-info-window>
                </map-marker>
                <!-- Intermediários -->
                @for (waypoint of mapaCliente.waypoints; track waypoint; let j = $index) {
                  <map-marker [position]="{lat: waypoint.location.lat, lng: waypoint.location.lng}" [visible]="mapaCliente.visible" (mapClick)="alternarPonto(j + 1, false)" (mouseenter)="onMouseOver(infoWindowIntermediarios, maps)" (mouseleave)="onMouseOut(maps)" [options]="{icon: mapaCliente.markerOptions.waypoints[j].icon.selecionado ? 'assets/pins/sem_rota/sem_rota_selecao.png' : mapaCliente.markerOptions.waypoints[j].icon}">
                    <agm-info-window #infoWindowIntermediarios [isOpen]="mapaClienteComRotaSelecionado == i && mapaClienteComRotaPontoSelecionado == (j + 1)" [disableAutoPan]="false">
                      <div class="d-flex align-items-baseline">
                        <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(mapaCliente.markerOptions.waypoints[j].infoWindow)"></div>
                        @if (!rotasNova) {
                          <div class="rotas_informacao">
                            <div class="form-group col-sm-12">
                              <label>Enviar p/ rota:</label>
                              <select class="form-control form-control-sm" name="rota_destino_6" #rota_destino_6 (change)="definirPosicoesRotaDestino($event.target.value)">
                                @for (opcao of rotasAgrupadas; track opcao; let i = $index) {
                                  <option [value]="opcao.key" [selected]="i == rotaSelecionada" [hidden]="opcao.key == clientesSemRota">{{ opcao.key }}</option>
                                }
                              </select>
                            </div>
                            <div class="form-group col-sm-12">
                              <label>Posição:</label>
                              <select class="form-control form-control-sm" name="rota_posicao_6" #rota_posicao_6 (change)="definirPosicao($event.target.value)">
                                @for (opcao of rotaSelecionadaPosicoes; track opcao; let i = $index) {
                                  <option [value]="opcao" [selected]="i == rotaPosicaoSelecionada">{{ opcao + 1 }}</option>
                                }
                              </select>
                              <hr class="mt-2 mb-2" />
                            </div>
                            <div class="col-sm-12">
                              <div class="d-flex justify-content-center">
                                <div>
                                  <button class="btn btn-success btn_rotas_informacao" (click)="modalReposicionarCliente(reposicionarCliente, true, j + 1)">Reposicionar</button>
                                </div>
                                <div class="pl-2">
                                  <button class="btn btn-success btn_rotas_informacao" (click)="moverPonto(j + 1, false)">Mover</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </agm-info-window>
                  </map-marker>
                }
              }
            </google-map>
          </as-split-area>
          <!-- Drag and Drop -->
          @if (exibirDragAndDrop) {
            <as-split-area size="45" style="overflow-x: auto">
              <!-- 45 -->
              <div class="container-fluid p-0">
                <div class="borda_superior pt-1 pr-4 pb-1 pl-4">
                  <div class="d-flex">
                    @for (rotaAgrupada of rotasAgrupadas; track rotaAgrupada; let i = $index) {
                      @if (rotaAgrupada.visualizar) {
                        <div class="rotas_coluna">
                          <!-- Cabeçalho (Coluna) -->
                          <div class="d-flex flex-column">
                            <div class="d-flex">
                              <div (click)="expandirRecolherRota(i)">
                                <i class="fa rotas_acoes" [ngClass]="rotasAgrupadas[i].exibir ? 'fa-minus' : 'fa-plus'" placement="right" ngbTooltip="Expandir/Recolher"></i>
                              </div>
                              @if (rotasAgrupadas[i].exibir) {
                                <div class="flex-grow-1 rotas_nome">
                                  <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-between">
                                      <div>
                                        <b>{{ rotasAgrupadas[i].key }} ({{ rotasAgrupadas[i].value.length }})</b>
                                      </div>
                                      <div class="d-flex">
                                        @if (rotasAgrupadas[i].key != clientesSemRota) {
                                          <div (click)="iniciarAlterarRota(alterarRota, i)">
                                            <i class="fa fa-pencil rotas_acoes" placement="left" ngbTooltip="Alterar"></i>
                                          </div>
                                        }
                                        @if (rotasAgrupadas[i].key != clientesSemRota) {
                                          <div (click)="modalExcluirRota(excluirRota, rotasAgrupadas[i].route_id_app)">
                                            <i class="fa fa-remove rotas_acoes" placement="left" ngbTooltip="Excluir"></i>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="rotas_descricao">
                                      Dia (Visita):
                                      @if (rotasAgrupadas[i].dia_visita == null) {
                                        -
                                      }
                                      @if (rotasAgrupadas[i].dia_visita != null) {
                                        {{ rotasAgrupadas[i].dia_visita | date: 'dd/MM/yyyy' }}
                                      }
                                    </div>
                                    <div class="rotas_descricao">
                                      Distância: {{ rotasAgrupadas[i].distancia_rota }}
                                    </div>
                                    <div class="rotas_descricao">
                                      Objetivo: {{ rotasAgrupadas[i].total_objetivo_de_venda | currency: 'BRL' : '' }}
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                            @if (!rotasAgrupadas[i].exibir) {
                              <div class="rotas_nome_rotacao" placement="top" ngbTooltip="{{ rotasAgrupadas[i].key }} ({{ rotasAgrupadas[i].value.length }})">
                                <div class="rotas_nome_rotacionado">
                                  <b>{{ rotasAgrupadas[i].key }} ({{ rotasAgrupadas[i].value.length }})</b>
                                </div>
                              </div>
                            }
                          </div>
                          <!-- Itens -->
                          @if (rotasAgrupadas[i].exibir) {
                            <div class="rotas_areas" dndEffectAllowed="move" (dndDrop)="onDrop($event, rotasAgrupadas[i].route_id_app, rotasAgrupadas[i].key, rotasAgrupadas[i].value)" dndDropzone>
                              <div class="rotas_destino" dndPlaceholderRef></div>
                              @for (rota of rotasAgrupadas[i].value; track rota; let j = $index) {
                                @if (clienteCorrespondeFiltro(rota)) {
                                <div class="rotas_item" [ngClass]="rota.reposicionar ? 'rotas_item_reposicionar' : ''"
                                  [dndDraggable]="rota"
                                  [dndEffectAllowed]="rota.effectAllowed"
                                  [dndDisableIf]="rota.disable"
                                  [style.border-color]="rotasAgrupadas[i].cor"
                                  (dndStart)="onDragStart($event)"
                                  (dndCopied)="onDragged(rota, rotasAgrupadas[i].value, 'copy')"
                                  (dndLinked)="onDragged(rota, rotasAgrupadas[i].value, 'link')"
                                  (dndMoved)="onDragged(rota, rotasAgrupadas[i].value, 'move')"
                                  (dndCanceled)="onDragged(rota, rotasAgrupadas[i].value, 'none')"
                                  (dndEnd)="onDragEnd($event)"
                                  (click)="selecionarPonto(i, j)">
                                  <div class="d-flex">
                                    <div class="pr-1">
                                      @if (rotasAgrupadas[i].key == clientesSemRota) {
                                        <div class="rotas_numero" [style.background-color]="rotasAgrupadas[i].cor">?</div>
                                      }
                                      @if (rotasAgrupadas[i].key != clientesSemRota) {
                                        <div class="rotas_numero" [style.background-color]="rotasAgrupadas[i].cor">{{ j + 1 }}</div>
                                      }
                                    </div>
                                    <div class="flex-grow-1">
                                      <div class="d-flex flex-column">
                                        <div>
                                          <b>{{ rota.name }}</b>
                                        </div>
                                        <div>
                                          Distância: {{ rota.distancia }}
                                        </div>
                                        <div>
                                          Frequência:
                                          @if (rotasAgrupadas[i].key == clientesSemRota) {
                                            -
                                          }
                                          @if (rotasAgrupadas[i].key != clientesSemRota) {
                                            {{ rota.frequencia_qtde_atual }} / {{ rota.visita_frequencia }} <i class="fa rotas_acoes" [ngClass]="rota.frequencia_qtde_atual == rota.visita_frequencia ? 'fa-check' : 'fa-asterisk'"></i>
                                          }
                                        </div>
                                        <div>
                                          Objetivo: {{ rota.objetivo_de_venda | currency: 'BRL' : '' }}
                                        </div>
                                      </div>
                                    </div>
                                    @if (rotasAgrupadas[i].key != clientesSemRota) {
                                      <div>
                                        <i class="fa fa-tags btn_tabela_acao" placement="left" ngbTooltip="Duplicar" (click)="modalDuplicarCliente(duplicarCliente, j, i)"></i>
                                      </div>
                                      <div class="pl-2">
                                        <i class="fa fa-globe btn_tabela_acao" placement="left" ngbTooltip="Reposicionar" (click)="modalReposicionarCliente(reposicionarCliente, false, j, i)"></i>
                                      </div>
                                      <div class="pl-2">
                                        <i class="fa fa-remove btn_tabela_acao" placement="left" ngbTooltip="Desativar" (click)="desativarPonto(rota.route_client_id, rota.route_id_app, i, j)"></i>
                                      </div>
                                    }
                                  </div>
                                </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            </as-split-area>
          }
        </as-split>
      </div>
    </div>
  }
</div>
